import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Branch-aware letterhead for printed documents. Falls back to the
// clinic profile from AuthContext until / unless a branch_id is known.
export default function useBranchClinic(branchId) {
  const { clinic } = useAuth();
  const [state, setState] = useState({ id: null, data: null });
  useEffect(() => {
    if (!branchId) return undefined;
    let cancelled = false;
    axios.get(`${API}/settings/clinic`, { params: { branch_id: branchId } })
      .then((r) => { if (!cancelled) setState({ id: branchId, data: r.data || null }); })
      .catch(() => { if (!cancelled) setState({ id: branchId, data: null }); });
    return () => { cancelled = true; };
  }, [branchId]);
  if (!branchId) return clinic;
  // `__loading` lets print buttons wait so the main address never prints by mistake.
  if (state.id !== branchId) return { ...(clinic || {}), __loading: true };
  return state.data ? { ...(clinic || {}), ...state.data } : clinic;
}
